import { graphql } from 'react-relay';

export const AIPresetCategoriesQuery = graphql`
    query aiPresetCategoriesQuery($toolId: String!, $presetType: String) {
        aiPresetCategories(toolId: $toolId, presetType: $presetType) {
            id
            name
            sellerID
        }
    }
`;
